module.exports = __webpack_public_path__ + "static/media/purchaise.06a4894b.png";